import { render, staticRenderFns } from "./NextcloudStats.vue?vue&type=template&id=ff16f3da&scoped=true&"
import script from "./NextcloudStats.vue?vue&type=script&lang=js&"
export * from "./NextcloudStats.vue?vue&type=script&lang=js&"
import style0 from "./NextcloudStats.vue?vue&type=style&index=0&id=ff16f3da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff16f3da",
  null
  
)

export default component.exports